import { classifyPassengerServices } from './passengerServiceNormalizer';
import { REWARD_TIERS } from './rewardTier';

const rewardGoldUrl = require('../images/reward-gold.svg').default;
const rewardSilverUrl = require('../images/reward-silver.svg').default;
const rewardBronzeUrl = require('../images/reward-bronze.svg').default;

const REWARD_ICON_URLS = {
    gold: rewardGoldUrl,
    silver: rewardSilverUrl,
    bronze: rewardBronzeUrl,
};

export const getRewardTierIconUrl = (reward) => {
    if (!reward?.iconKey) {
        return null;
    }

    return REWARD_ICON_URLS[reward.iconKey] || null;
};

const REWARD_TIER_COLOR_BY_KEY = REWARD_TIERS.reduce((acc, tier) => {
    acc[tier.key] = tier.color;
    return acc;
}, {});

const NAVY_INK = '#15273f';

// Compact seat-map badge: single letter + tier color, with a legible letter color.
const REWARD_TIER_BADGES = {
    gold: { letter: 'G', fg: NAVY_INK },
    silver: { letter: 'S', fg: NAVY_INK },
    bronze: { letter: 'B', fg: NAVY_INK },
};

/**
 * Returns a compact tier badge descriptor { letter, bg, fg } for the seat map,
 * or null when the reward has no displayable tier.
 */
export const getRewardTierBadge = (reward) => {
    const tierKey = reward?.tierKey;
    const badge = tierKey ? REWARD_TIER_BADGES[tierKey] : null;
    if (!badge) {
        return null;
    }

    return {
        letter: badge.letter,
        bg: REWARD_TIER_COLOR_BY_KEY[tierKey] || NAVY_INK,
        fg: badge.fg,
    };
};

export const getSeatHighlightColor = (
    passenger,
    selectedFilter,
    mealModeOn = false,
    passengerHasSeat = true
) => {
    // Empty seat or explicitly no passenger bound to this seat
    if (!passengerHasSeat || !passenger) {
        return '#F9F9F9'; // Empty seat
    }

    // Meal mode takes precedence
    if (mealModeOn && passenger?.mealObject) {
        return passenger.mealReceived ? '#c0e0b0' : '#D3D3D3';
    }

    const { boarded, checkedIn } = passenger || {};

    if (boarded) return '#DAEFD3';   // Light green
    if (checkedIn) return '#DAEBFF'; // Light blue
    return '#FFFFFF';                 // White
};

export const getSeatBorderColor = (
    passenger,
    mealModeOn = false,
    passengerHasSeat = true
) => {
    if (!passengerHasSeat || !passenger) {
        return '#C3C3C3'; // Gray border for empty
    }

    if (mealModeOn && passenger?.mealObject) {
        return '#2A5980'; // Dark blue
    }

    const { boarded, checkedIn } = passenger || {};
    if (boarded) return '#238E00';   // Dark green
    if (checkedIn) return '#15273F'; // Dark blue
    return '#2A5980';                 // Blue
};

const REWARD_ROW_CLASS_BY_TIER = {
    gold: 'reward-gold-row',
    silver: 'reward-silver-row',
    bronze: 'reward-bronze-row',
};

/**
 * Gets row CSS class names for ListView based on passenger properties and filters
 */
export const getListViewRowClasses = (passenger) => {
    const classes = [];

    // Meal received
    if (passenger.mealReceived) {
        classes.push('meal-received-row');
    }

    const classification = classifyPassengerServices(passenger);
    const rewardRowClass = classification.reward?.tierKey
        ? REWARD_ROW_CLASS_BY_TIER[classification.reward.tierKey]
        : null;

    if (rewardRowClass) {
        classes.push(rewardRowClass);
    }

    return classes.join(' ');
};

